import saleLine from "./ModelSaleLine";
import tools from "tools/dates";
import proxy from "api/proxy";
import funcs from "tools/functions";

import AddProduct from "../Components/AddProduct";
import WizardAddPayment from "../Components/WizardAddPayment";
import { getStorage, setStorage } from "store/local";
import QRCode from "qrcode";

const ctxSession = getStorage("ctxSession");

const today = tools.dateToday();
const todayConvert = new Date(today);
const month = todayConvert.setMonth(todayConvert.getMonth() - 1);
const _month = tools.fmtDate2Tryton(new Date(month));
const month_3 = todayConvert.setMonth(todayConvert.getMonth() - 3);
const _month_3 = tools.fmtDate2Tryton(new Date(month_3));
const month_6 = todayConvert.setMonth(todayConvert.getMonth() - 6);
const _month_6 = tools.fmtDate2Tryton(new Date(month_6));

const ComponentAddProduct = ({ record }) => {
  return AddProduct("comment", record);
};
const getReadonly = (record) => {
  if (record?.number || record.state !== "draft") return true;
  return false;
};
const getAddress = (value, record) => {
  const party_id = record?.party?.id;

  const dom = party_id ? [["party", "=", party_id]] : [];
  if (value > 2) {
    dom.push(["rec_name", "ilike", `%${value}%`]);
  }
  return dom;
};
const onChangeAddress = (activeRec, storeRec) => {
  storeRec.invoice_address = storeRec.shipment_address;
  activeRec.invoice_address = activeRec.shipment_address;
};
const getFilters = () => {
  return {
    today: [
      [
        "OR",
        ["sale_date", "=", `${today}`],
        ["create_date", ">=", `${today} 00:00:00`],
      ],
      ["agent.user", "=", ctxSession?.user],
    ],
    month: [
      [
        ["sale_date", "<=", `${today}`],
        ["sale_date", ">=", `${_month}`],
      ],
      ["agent.user", "=", ctxSession?.user],
    ],
    month_3: [
      [
        ["sale_date", "<=", `${today}`],
        ["sale_date", ">=", `${_month_3}`],
      ],
      ["agent.user", "=", ctxSession?.user],
    ],
    month_6: [
      [
        ["sale_date", "<=", `${today}`],
        ["sale_date", ">=", `${_month_6}`],
      ],
      ["agent.user", "=", ctxSession?.user],
    ],
  };
};

const stateColors = {
  none: "slate",
  quotation: "amber",
  processing: "sky",
  done: "lime",
  canceled: "rose",
};
const defaultAgent = async () => {
  const session = getStorage("ctxSession");
  const dom = [["user", "=", session.user]];
  const fields = ["id", "rec_name"];
  const { data } = await proxy.search("commission.agent", dom, fields, 1);
  return data[0];
};

const defaultWarehouse = async () => {
  const user = ctxSession?.user;
  console.log(ctxSession, "---session");

  const { data, error } = await proxy.search(
    "res.user",
    [["id", "=", user]],
    ["id", "warehouse.name"],
  );
  if (data && data.length > 0) {
    const warehouse = data[0]["warehouse."];
    await setStorage({ ...ctxSession, locations: [warehouse.id] });
    return warehouse;
  }
};

function isVisibleSend(name, record) {
  console.log(record, "esto son los records");

  let res = false;
  if (record?.id < 0) {
    res = true;
  }
  return res;
}

const visiblePrint = (name, record) => {
  let res = false;
  if (
    // record.state === "draft" ||
    record.state === "processing" ||
    record.state === "quote" ||
    record.state === "done" ||
    (record?.payment_term?.payment_type == "2" && record.state === "draft")
  ) {
    res = true;
  }
  return res;
};

function getQrCode(url) {
  return QRCode.toString(url, { type: "svg" });
}

const onPrintBrowser = async (record) => {
  const model = "sale.sale";
  const fieldsActi = ["id"];
  const session = getStorage("ctxSession");
  const terminal = funcs.getCookie();
  const args = { user_id: session.user, device_id: Number(terminal.device_id) };
  const INVOICE_TYPE = {
    P: "SISTEMA POS:",
    1: "FACTURA DE VENTA ELECTRONICA:",
    M: "MANUAL:",
  };
  const { data: ctxPrinting } = await proxy.methodCall({
    model: model,
    method: "get_printing_context",
    args: [args],
  });
  const argSale = {
    type_doc: "invoice",
    sale_id: record.id,
  };
  const { data: sale } = await proxy.methodCall({
    model: model,
    method: "get_data",
    args: [argSale],
  });
  const styleSeparator =
    "border-top: 1px dashed; margin-top:0.5cm; margin-bottom:0.5cm";

  let infoTransfer = "";
  let _sale = { ...record, ...sale };

  _sale.order = sale?.order;
  _sale.payment_term = sale?.payment_term;
  _sale.create_date = new Date(record.sale_date);
  _sale.create_date = _sale.create_date.toLocaleDateString();
  _sale.party_address = record.party.address;
  if (_sale.courtesy) {
    _sale.total_discount_amount = _sale["lines."].reduce((total, item) => {
      return total + item.base_price * item.quantity;
    }, 0);
  }
  let imageQr = "";
  if (sale && sale.qr_code) {
    imageQr = await getQrCode(sale?.qr_code, 30, 30);
  }

  if (record.state !== "transferred" && record.invoice_type != "M") {
    // _sale = { ...record };
    _sale.party = record.party.rec_name;
    _sale.party_id_number = record.party.id_number;
    _sale.party_phone = record.party.mobile;

    _sale.untaxed_amount = _sale.total_amount;
    const _saleLine = _sale["lines."].map((act) => {
      let name = act.product.name;
      const dataInvoice = {
        name: `${name}`,
        unit_price_w_tax: act.amount,
        amount_w_tax: act.product.amount_w_tax,
        quantity: act.quantity,
        taxes: act.taxes,
        discount: act.discount,
      };
      return dataInvoice;
    });
    _sale.lines = _saleLine;
  } else {
    infoTransfer =
      "<div style='text-align:center; margin-top: 1.5cm; border-top: 1px dashed;margin-bottom: 0.5cm; padding-top: 0.1cm;'>Firma</div>";

    _sale.party = record.party.rec_name;
    _sale.party_id_number = record["party."].id_number;
    _sale.party_address = record["party."].address;
    _sale.party_phone = record["party."].mobile;
    _sale.payment_term =
      _sale.state == "transferred" ? "Transferido" : "Cortesia";

    let _saleLine = _sale["lines."].map((act) => {
      console.log("this is product", act);
      return {
        name: act.product.rec_name || act.product.name,
        origin: act.origin,
        unit_price_w_tax: act.unit_price,
        amount_w_tax: act.amount_w_tax,
        quantity: act.quantity,
        taxes: act.product.taxes,
        discount: act.discount,
      };
    });

    _sale.lines = _saleLine;
    console.log(sale, "this is sale for get number");
    console.log(_sale.lines, "_sale.lines");
  }
  let html = `
    <div style="margin-top: 0.5cm; margin-bottom: 0.5cm; display: flex; justify-content: space-between; border-top: 1px dashed; border-bottom: 1px dashed; padding: 2mm;">
      <div>Articulo</div>
      <div>Subtotal</div>
    </div>
    ${sale.lines
      .map(
        (item) => `
      <div style="display: flex; justify-content: space-between;margin-bottom: 0.1cm;">
        <div style="width:70%">${item?.name}  ${
          item?.quantity != 1 ? "x " + item?.quantity : ""
        } ${item?.discount ? "DESC - " + item?.discount : ""}</div>
        <div style="width:30% text-align:rigth">${item?.amount_w_tax.toLocaleString("es-CO")} </div>
      </div>
    `,
      )
      .join("")}
    <div style="display: flex; justify-content: space-between;">
      <div>Impuestos:</div>
      <div style="text-align: right;">0</div>
    </div>
    <div style="display: flex; justify-content: space-between; margin-top: 0.5cm; ">
    <div>Total:</div>
    <div style="text-align: right;">
    <div style="border-top: 1px dashed; width: 20mm; margin-bottom: 0.1cm; "></div>
    ${_sale.paid_amount.toLocaleString("es-CO") || _sale.total_amount.toLocaleString("es-CO")}
    </div>
    </div>
    <div style="display: flex; justify-content: space-between;">
    ${
      _sale.courtesy &&
      `<div>Total Complimentary:</div>
      <div style="text-align: right;">
      ${_sale.total_discount_amount}
      </div>`
    }
    </div>
  `;

  let htmlTax;
  if (record.state != "transferred") {
    htmlTax = `<div>DETALLE DE IMPUESTOS</div>
  <div
    style="${styleSeparator}; border-top:1px dashed ; border-botton:1px dashed; margin-top: 0.5cm;
  margin-bottom: 0.5cm;"
  ></div>
  <div style="display: flex; gap: 0.2cm; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <div>MEDIO PAGO</div>
      <div># APROB</div>
      <div>VALOR</div>
    </div>
    ${_sale.payments
      .map(
        (item) => `
        <div style="display: flex; justify-content: space-between">
        <div>${item.name}</div>
        <div>${item?.voucher || ""} </div>
        <div>${item.amount} </div>
      </div>
    `,
      )
      .join("")}

  </div>
  <div
    style="${styleSeparator}; border-top:1px dashed ; border-botton:1px dashed; margin-top: 0.5cm;
margin-bottom: 0.5cm;"
  ></div>
  <div style="display: flex; justify-content: space-between">
    <div>No ITEMS:</div>
    <div>${_sale.lines.length}</div>
  </div>
  <div style="display: flex; justify-content: space-between">
    <div>No PEDIDO:</div>
    <div>${_sale.order}</div>
  </div>
  <div style="display: flex; justify-content: space-between">
    <div>CAJA No.:</div>
    <div>${ctxPrinting.sale_device}</div>
  </div>
  <div style="display: flex; justify-content: space-between">
    <div>CAJERO:</div>
    <div>${ctxPrinting.user}</div>
  </div>
  <div style="display: flex; justify-content: space-between">
  <div>VENDEDOR:</div>
  <div>${sale?.agent}</div>
</div>
  <div
  style="${styleSeparator}; border-top:1px dashed ; border-botton:1px dashed; margin-top: 0.5cm;
margin-bottom: 0.5cm;"
></div>
  <div>Autorizacion de facturacion ${
    ctxPrinting?.authorizations[sale.invoice_type]?.kind
  } No ${ctxPrinting.authorizations[sale.invoice_type]?.number} del ${
    ctxPrinting.authorizations[sale.invoice_type]?.start_date_auth
  } hasta ${
    ctxPrinting.authorizations[sale.invoice_type]?.end_date_auth
  }, habilita desde ${ctxPrinting.authorizations[sale?.invoice_type]?.prefix}${
    ctxPrinting.authorizations[sale.invoice_type]?.to_auth
  } a ${ctxPrinting.authorizations[sale.invoice_type]?.prefix}${
    ctxPrinting.authorizations[sale.invoice_type]?.from_auth
  }</div>
    <div style = "width:100%;  word-wrap: break-word; margin-top: 0.2cm;">CUFE:${
      sale.invoice_type == "1" ? sale.cufe : ""
    }</div>
    <div style= "max-width: 140px; margin: 0px 50;">${imageQr}</div>`;
  }
  const title =
    record.state !== "transferred"
      ? INVOICE_TYPE[record.invoice_type]
      : "TRANSFERIDO";
  console.log(sale, "this is sale for get number");
  const number = _sale?.number ?? _sale?.order;
  const typeSystem = ` <div>${title} ${number}</div>`;

  const contenidoHTML = `    <div style="width: 100%; padding: 0.1cm; font-family: monospace; font-size: 2.8mm">
  <div style="text-align: center; margin-bottom: 0.5cm" >
    <div style="margin-bottom: 0.5cm"><center><img src="https://res.cloudinary.com/dl4sdiukx/image/upload/v1741280790/cirdhqip0r5flrcgxby3.png" width="60%" > </center></div>
    <div>${ctxPrinting.company}</div>
    <div>${ctxPrinting.shop}</div>
    <div>NIT: ${ctxPrinting.id_number} ${ctxPrinting.regime_tax}</div>
    <div>${ctxPrinting.street}</div>
    <div>${ctxPrinting.city} Telefono: ${ctxPrinting.phone}</div>
  </div>
  ${typeSystem}
  <div>Fecha: ${_sale.create_date}</div>
  <div style="${styleSeparator}"></div>
  <div>
    <div>Cliente: ${sale.party}</div>
    ${_sale.description ? `<div>Nombre: ${_sale?.description}</div>` : ""}
    <div>ID: ${sale.party_id_number}</div>
    <div>Direccion: ${sale?.party_address || ""}</div>
    <div>Telefono: ${sale.party_phone}</div>
    <div>Forma de Pago: ${sale.payment_term}</div>
  </div>
  ${html}
  <div
    style="${styleSeparator}; border-top:1px dashed ; border-botton:1px dashed; margin-top: 0.5cm;
    margin-bottom: 0.5cm;"
  ></div>
  ${htmlTax || ""}
  ${infoTransfer || ""}
  <div>Fecha de creación: ${_sale.create_date} </div>
  <div style="margin-top: 0.5cm; text-align:center">NIT: 900803782-2</div>
  <div style=" text-align:center">SOFTWARE TRYTON - www.presik.com</div>
</div>
<div>
</div>
`;

  const ventana = window.open("", "", "width=100%,height=auto");
  ventana.document.open();
  ventana.document.write(contenidoHTML);
  ventana.document.close();
  ventana.print();
};

const getTotalAmount = (record) => {
  let totalAmount = 0;
  if (!record.lines && record.total_amount) return record.total_amount;
  record?.lines?.forEach((item) => {
    totalAmount = totalAmount + parseFloat(item.amount_w_tax);
  });
  return totalAmount;
};

const getUntaxedAmount = (record) => {
  let totalAmount = 0;
  record?.lines?.forEach((item) => {
    totalAmount =
      totalAmount +
      parseFloat(
        item.amount ?? parseFloat(item.quantity) * parseFloat(item.unit_price),
      );
  });
  return totalAmount;
};

const visiblePay = (name, record) => {
  console.log(record.state, "record.state");

  let res = false;
  if (
    record.lines &&
    record.lines.size > 0 &&
    record.party &&
    record.residual_amount != 0 &&
    record.state !== "done" &&
    record.state !== undefined
  ) {
    res = true;
  }
  return res;
};
const visibleConfirm = (name, record) => {
  let res = false;
  if (
    !record.state &&
    record.lines &&
    record.lines.size > 0
    // record.id > 0
  ) {
    res = true;
  }

  return res;
};

const getView = (config) => {
  let DictCtxView = {
    selectable: false, // options: multi - one - false
    activeSearch: true,
    form_action_add: "modal",
    filters: getFilters,
    domain: [],
    // domain: ["shipping_date", ">=", `${today}`],
    pagination: [],
    tags: {
      state: stateColors,
    },
    limit: 50,
    form_action: ["save", "edit", "add"],
    table_action: ["open", "add"],
    model: "sale.sale",
    webfields: {
      number: {
        type: "char",
        readOnly: true,
        searchable: true,
      },
      party: {
        type: "many2one",
        model: "party.party",
        required: true,
        attrs: [
          "invoice_type",
          "sale_price_list",
          "sale_price_list.name",
          "customer_payment_term",
          "customer_payment_term.name",
          "account_receivable",
        ],
        // readOnly: true,
        searchable: true,
      },
      warehouse: {
        type: "many2one",
        model: "party.party",
        // required: true,
        default: defaultWarehouse,
        // readOnly: true,
        searchable: true,
      },
      payment_term: {
        type: "many2one",
        required: true,
        model: "account.invoice.payment_term",
        attrs: ["payment_type", "payment_type.name"],
        // withChange: onChangePaymentTerm,
        // options: getOptions(),
        translate: true,
        // default: defaultPaymentTerm,
        // readOnly: true,
      },
      sale_date: {
        type: "date",
        // default: new Date(),
        // readOnly: true,
        // searchable: true,
      },
      // shipping_date: {
      //   type: "date",
      //   required: false,
      //   readOnly: false,
      // },
      total_amount: {
        type: "numeric",
        readOnly: true,
        function: getTotalAmount,
        search: true,
        decimalPlaces: 2,
      },
      shipment_address: {
        type: "many2one",
        model: "party.address",
        recSearch: getAddress,
        withChange: onChangeAddress,
        required: true,
        // readOnly: getReadonly,
        readOnly: false,
      },
      agent: {
        type: "many2one",
        model: "commission.agent",
        recSearch: () => [["user", "=", session.user]],
        default: defaultAgent,
        readOnly: true,
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
        tags: stateColors,
      },
      reference: {
        type: "char",
        readOnly: true,
        searchable: true,
      },
      code: {
        type: "custom_button",
        model: "sale.sale",
        Component: ComponentAddProduct,
      },
      invoice_state: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      invoices: {
        type: "button_custom_modal",
        readOnly: true,
        color: "blue",
        search: true,
        desired_action: "count",
      },
      shipments: {
        type: "button_custom_modal",
        readOnly: true,
        color: "blue",
        search: true,
        desired_action: "count",
      },

      shipment_state: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      lines: {
        type: "one2many",
        model: "sale.line",
        ctxView: saleLine.ctxView(config),
        // required: true,
        readOnly: { state: ["quotation"] },
      },
      untaxed_amount: {
        type: "numeric",
        readOnly: true,
        function: getUntaxedAmount,
        decimalPlaces: 2,
        search: true,
      },
      // comment: { type: "text", readOnly: true },
      description: { type: "char" },

      invoice_type: {
        type: "radio",
        // default: "1",
        options: [
          { value: "1", text: "ELECTRONICA" },
          { value: "M", text: "MANUAL" },
        ],
        required: true,
      },
      residual_amount: {
        type: "numeric",
        readOnly: true,
      },
      paid_amount: {
        type: "numeric",
        readOnly: true,
      },
      comment: {
        type: "text",
      },
      send_order: {
        type: "button",
        button_method: "send_order",
        visible: isVisibleSend,
        // save: true,
      },
      print: {
        type: "button",
        method: onPrintBrowser,
        visible: visiblePrint,
        size: "p-22 !w-full",
        color: "amber",
        size: "!w-full",
      },
      add_payment: {
        type: "button_wizard",
        Component: WizardAddPayment,
        color: "lime",
        // icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
        style: "!w-full",
        visible: visiblePay,
        resetWizard: false,
      },
      quote: {
        type: "button",
        button_method: "quote",
        // visible: visibleQuote,
        visible: visibleConfirm,
        style: "p-22 !w-full",
      },
      confirm: {
        type: "button",
        button_method: "confirm",
        onSuccessMsg: "ORDEN DE COMPRA CONFIRMADA!",
        color: "pink",
      },
    },
    webtree: [
      // { name: "number", widget: "qr" },
      { name: "sale_date" },
      { name: "number" },
      { name: "party" },
      { name: "comment" },
      { name: "total_amount" },
      { name: "state", widget: "circle" },
    ],
    webform: [
      {
        id: "infoSale2",
        grid: [
          { name: "party" },
          { name: "shipment_address" },
          { name: "state" },
          { name: "sale_date" },
          { name: "number" },
          { name: "invoice_type" },
          { name: "payment_term" },
        ],
        size: [1, 4],
        colSpan: "col-span-2",
      },

      { name: "comment", colspan: "col-span-2" },
      { name: "code" },
      { name: "lines", component: "modal" },
      // { name: "custom" },
      { name: "agent" },
      { name: "warehouse", size: [2, 2], span: "col-span-2" },
      {
        id: "paid",
        grid: [
          { name: "untaxed_amount", width: "7%" },
          { name: "paid_amount" },
          { name: "residual_amount" },
          { name: "total_amount" },
        ],
        size: [1, 4],
        span: "col-span-2",
        colSpan: "col-span-2",
      },
      {
        id: "buttons",
        grid: [{ name: "quote" }, { name: "add_payment" }, { name: "print" }],
        size: [1, 3],
        span: "col-span-2",
      },

      // {
      //   id: "buttons",
      //   grid: [
      //     { name: "untaxed_amount", width: "7%" },
      //     { name: "paid_amount" },
      //     { name: "residual_amount" },
      //     { name: "total_amount" },
      //   ],
      //   size: [1, 4],
      //   span: "col-span-2",
      //   colSpan: "col-span-2",
      // },
      // {
      //   id: "buttons",
      //   grid: [{ name: "quote" }, { name: "add_payment" }, { name: "print" }],
      //   size: [1, 3],
      //   span: "col-span-2",
      // },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
